import {useState,useEffect} from 'react';
import {auth,db} from '.././dashboard/firebase/firebase';
import {addDoc, collection,getDocs,query} from 'firebase/firestore';
import {initializeApp} from 'firebase/app'
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import queryString from 'query-string';
import {useNavigate} from 'react-router-dom';
import { encrypt } from '../../encryption';
const Admin =()=>{
  const navigate = useNavigate();
  const url= queryString.parse(window.location.search);
  
  const admin =['owoadeanuoluwapo2@gmail.com','ogbonnaemmanuel494@gmail.com', 'Psalmsheg@gmail.com'];
  const [lin,setLin]=useState(false);
  if(url.admin != undefined){
     if(admin.includes(url.admin)){
       setLin(true)

     }else{alert(false)}
  }else{alert('no admin in url')}

  const [pack,setPackage]=useState(null);
  const [used,setUsed]=useState(null);
  const [unused, setUnUsed]=useState(null);
  const all_unused=[];
  const all_used=[];
  const get_coupon_key=(type)=>{
    var key;
    switch(type){
      case "starter":
        key = "STAR";
        break;
      case "premium":
        key = "PREM";
        break; 
      case "premium pro":
        key = "PREMP";
        break;   
      case "elite":
        key = "ELIT";
        break;
      case "expert":
        key = "EXPE";
        break; 
      case "worker":
        key = "WORK";
        break;  
    }
    return key;
  }
  const sign_in=()=>{
   const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider).then((re) => {

     if(admin.includes(re._tokenResponse.email)){
        navigate(`/admin/main?admin=${encrypt(re._tokenResponse.email)}`)
      }else{
        alert('You are not an admin');
      }

   })
  }
  const generate= async ()=>{
    if(pack != null){
       const coupon_data = {
                       code:`${get_coupon_key(pack)}_${Date.now()}`,
                       package_type:pack,
                       time: Date.now()
                    }
       const docRef = await addDoc(collection(db, "coupon"), coupon_data)
//        window.location.reload()
     }else{
       alert('Select a valid package type')
     }   
  }
  useEffect(()=>{
      if(used==null){
            (async () => {
                const q = query(collection(db, "user"));
                const querySnapshot = await getDocs(q);
                querySnapshot.forEach((doc) => {
                   all_used.push(doc.data())
                });
                 setUsed(all_used.sort((a,b)=>{return b.time - a.time}));
//               setNotifications(all_not.sort((a,b)=>{return b.time - a.time}))
            })();
            
      }    
    },[used])
   useEffect(()=>{
      if(unused==null){
            (async () => {
                const q = query(collection(db, "coupon"));
                const querySnapshot = await getDocs(q);
                querySnapshot.forEach((doc) => {
                   all_unused.push(doc.data())
                });
                 setUnUsed(all_unused.sort((a,b)=>{return b.time - a.time}));
            })();
            
      }    
    },[unused])
  return (
    <div className="admin-container">
    { !lin && <button className="main-btn" onClick={sign_in}>Sign in as Admin</button> }
      { lin && <div className="main-admin">
      <h2>Generate Coupon code</h2>
      <select onChange={(e)=>{setPackage(e.target.value)}}>
        <option value="null">Select package</option>
        <option value="starter">Starter</option>
        <option value="premium">premium</option>
        <option value="premium pro">Premium pro</option>
        <option value="elite">Elite</option>
        <option value="expert">Expert</option>
        <option value="worker">Worker</option>
      </select>
      <button onClick={generate}>Generate</button>
          
        <h3>Used Coupon Codes </h3>

         {  used &&  <div className="box">
          {
           used.map(each=>(
           <div>
             <p>{each.coupon}</p> 
           </div>
           
           ))
         }
           </div>}
         <h3>All Coupon Codes </h3>

         {  unused &&  <div className="box">
          {
           unused.map(each=>(
           <div>
             <p>{each.code}</p> 
           </div>
           
           ))
           }
          
        
        </div> }
       
    
    </div> } 
    
    </div>
  )
}
export default Admin
